import React from "react";
import { Button } from "components/common/Button";
interface DialogActionButton {
  label: string;
  variant?: "primary" | "secondary";
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

interface DialogActionsProps {
  actions: DialogActionButton[];
}

export const DialogActions: React.FC<DialogActionsProps> = ({ actions }) => {
  return (
    <div className="flex justify-end gap-2 pt-4">
      {actions.map((action, index) => (
        <Button
          key={index}
          variant={action.variant || "primary"}
          size="md"
          onClick={action.onClick}
          disabled={action.disabled}
          loading={action.loading}
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
};
